import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import ViralPostGrader from "@/components/ViralPostGrader";
import VisionChat from "@/components/VisionChat";
import PasswordGate from "@/components/PasswordGate";
import StudioPasswordGate from "@/components/StudioPasswordGate";
import SovereignStudio from "@/components/SovereignStudio";

function App() {
  // Hostname- and path-based routing
  const hostname = window.location.hostname;
  const pathname = window.location.pathname || '';
  const isStudioPath = pathname === '/studio' || pathname.startsWith('/studio/');
  const isVisionDomain = hostname.startsWith('vision.') ||
                         hostname === 'vision.local' ||
                         window.location.search.includes('vision=true');
  const isStudioDomain = hostname.startsWith('studio.') ||
                         window.location.search.includes('studio=true') ||
                         isStudioPath;

  return (
    <div className="min-h-screen bg-background">
      {isStudioDomain ? (
        <StudioPasswordGate>
          <SovereignStudio />
        </StudioPasswordGate>
      ) : isVisionDomain ? (
        <PasswordGate>
          <VisionChat />
        </PasswordGate>
      ) : (
        <ViralPostGrader />
      )}
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
